import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Helper } from 'src/app/shared/classes/Helper';
import { HitApi } from 'src/app/shared/classes/HitApi';
import { Widget } from 'src/app/shared/classes/Widget';
import { WidgetInjectedData } from 'src/app/shared/classes/WidgetInjectedData';
import { ButtonColorType } from 'src/app/shared/enums/ButtonColorType';
import { ButtonType } from 'src/app/shared/enums/ButtonType';
import { IconType } from 'src/app/shared/enums/IconType';
import { IntegrationName } from 'src/app/shared/enums/IntegrationName';
import { ModalType } from 'src/app/shared/enums/ModalType';
import { IIntegrationApiResponse } from 'src/app/shared/interfaces/api/portlets/IIntegrationApiResponse';
import { IFormGeneratorInput } from 'src/app/shared/interfaces/form-generator/IFormGeneratorInput';
import { IIntegrationInput } from 'src/app/shared/interfaces/integration/IIntegrationInput';
import { IModalData } from 'src/app/shared/interfaces/modal/IModalData';
import { AutotaskIntegrationsTableComponent } from '../../../modal-templates/integration/autotask-modal/autotask-integrations-table/autotask-integrations-table.component';
import { AutotaskParentIntegrationStepOneComponent } from '../../../modal-templates/integration/autotask-modal/autotask-parent-integration-step-one/autotask-parent-integration-step-one.component';
import { AutotaskParentIntegrationStepTwoComponent } from '../../../modal-templates/integration/autotask-modal/autotask-parent-integration-step-two/autotask-parent-integration-step-two.component';
import { AutotaskChildIntegrationComponent } from './../../../modal-templates/integration/autotask-modal/autotask-child-integration/autotask-child-integration.component';

@Component({
    selector: 'app-autotask-integration',
    templateUrl: './autotask-integration.component.html',
    styleUrls: ['./autotask-integration.component.sass']
})
export class AutotaskIntegrationComponent implements OnInit, AfterViewInit {
    integrationInput: IIntegrationInput = null;
    widgetRef: Widget;
    isChildIntegrated = false;
    isParentIntegrated = false;
    isOwnerIntegrated = false;
    parentIntegrationConfigureFormGenInput: IFormGeneratorInput = null;
    isConfigured: Boolean = false;
    response: IIntegrationApiResponse;
    constructor(widgetData: WidgetInjectedData) {
        this.widgetRef = widgetData.widgetRef;
    }

    ngOnInit(): void {
        this.setUpBasics();
    }

    setUpBasics() {
        this.integrationInput = {
            integrationName: this.widgetRef.widgetData.widgetInfo.text,
            integrationCategory: 'ITSM Integration',
            imageUrl: 'assets/integrations/autotask_2.png',
            buttons: [],
            imagePadding: 6
        };
    }

    generateButtons(response: IIntegrationApiResponse) {
        this.isConfigured = false;
        if (
            this.isOwnerIntegrated ||
            this.isChildIntegrated ||
            this.isParentIntegrated
        ) {
            if (
                !this.isOwnerIntegrated &&
                this.isParentIntegrated &&
                !this.isChildIntegrated
            ) {
                this.isConfigured = true;
                // Adding edit button
                this.integrationInput.buttons.push({
                    buttonName: 'Edit',
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-wrench'
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Edit Autotask',
                    function: () => {
                        this.openParentIntegrationModal(
                            response,
                            'Edit Autotask'
                        );
                    }
                });

                // Adding delete button
                this.integrationInput.buttons.push({
                    buttonName: 'Delete',
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-trash'
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.WARN,
                    hoverText: 'Remove Autotask',
                    function: (modalId: Symbol) => {
                        // Delete integration
                        const args = Helper.generateHitApiConfig(
                            this.widgetRef.widgetData.widgetInfo.delete
                        );
                        args.input = {
                            parentIntegration: true,
                            childIntegration: false,
                            integrationType: IntegrationName.AUTOTASK
                        };
                        args.function = (response) => {
                            this.widgetRef.notificationsService.showSnackBar(
                                `Autotask integration removed successfully`
                            );
                            this.widgetRef.modalService.closeModal(
                                null,
                                modalId
                            );
                            this.widgetRef.refreshWidget();
                        };
                        args.errorFunction = (error) => {
                            Helper.showErrorMessage(
                                this.widgetRef.notificationsService,
                                error,
                                'Error removing autotask'
                            );
                            this.widgetRef.modalService.closeModal(
                                null,
                                modalId
                            );
                        };
                        new HitApi(
                            args,
                            this.widgetRef.httpService,
                            this.widgetRef.ngZone
                        ).hitApi();
                    },
                    executeFunctionAfterConfirmation: {
                        modalName: 'Remove Autotask Integration',
                        modalIcon: {
                            type: IconType.FONTAWSOME,
                            class: 'far fa-trash-alt'
                        },
                        contextIcon: {
                            extraClass: 'color-accent',
                            type: IconType.FONTAWSOME,
                            class: 'fas fa-exclamation-triangle'
                        },
                        confirmationMessage: `Are you sure you want to remove autotask ?`,
                        buttonText: 'Remove',
                        buttonColorType: ButtonColorType.WARN,
                        loaderOnExec: true
                    }
                });
            }

            if (
                this.isOwnerIntegrated &&
                !this.isParentIntegrated &&
                !this.isChildIntegrated
            ) {
                this.isConfigured = true;
                // Adding create button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'group_add'
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Perform child-level integration',
                    function: () => {
                        this.openChildIntegrationModal(response);
                    }
                });

                //Adding Integrate as Parent button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'person_add'
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Perform parent-level integration',
                    function: () => {
                        this.openParentIntegrationModal(
                            response,
                            'Autotask Setup'
                        );
                    }
                });
            }
            if (
                this.isOwnerIntegrated &&
                this.isParentIntegrated &&
                !this.isChildIntegrated
            ) {
                this.isConfigured = true;
                // Adding create button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'group_add'
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Perform child-level integration',
                    function: () => {
                        this.openChildIntegrationModal(response);
                    }
                });

                //Adding Integrate as Parent button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'person_add'
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    buttonClass: 'disabled',
                    hoverText: 'Perform parent-level integration',
                    function: () => {}
                });

                //Adding list icon
                this.integrationInput.buttons.push({
                    buttonName: 'View Existing',
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-bars '
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Existing Integrations',
                    function: () => {
                        this.openIntegrationsListingModal(response);
                    }
                });
            }
            if (
                this.isOwnerIntegrated &&
                !this.isParentIntegrated &&
                this.isChildIntegrated
            ) {
                this.isConfigured = true;
                // Adding create button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'group_add'
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    buttonClass: 'disabled',
                    hoverText: 'Perform child-level integration',
                    function: () => {}
                });
                this.isConfigured = true;
                //Adding Integrate as Parent button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'person_add'
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Perform parent-level integration',
                    function: () => {
                        this.openParentIntegrationModal(
                            response,
                            'Autotask Setup'
                        );
                    }
                });
                this.isConfigured = true;
                //Adding list icon
                this.integrationInput.buttons.push({
                    buttonName: 'View Existing',
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-bars '
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Existing Integrations',
                    function: () => {
                        this.openIntegrationsListingModal(response);
                    }
                });
            }
            if (
                this.isOwnerIntegrated &&
                this.isParentIntegrated &&
                this.isChildIntegrated
            ) {
                this.isConfigured = true;
                // Adding create button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'group_add'
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    buttonClass: 'disabled',
                    hoverText: 'Perform child-level integration',
                    function: () => {}
                });

                //Adding Integrate as Parent button
                this.integrationInput.buttons.push({
                    buttonName: 'Integrate',
                    buttonIcon: {
                        type: IconType.MATICON,
                        class: 'person_add'
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    buttonClass: 'disabled',
                    hoverText: 'Perform parent-level integration',
                    function: () => {}
                });

                //Adding list icon
                this.integrationInput.buttons.push({
                    buttonName: 'View Existing',
                    buttonIcon: {
                        type: IconType.FONTAWSOME,
                        class: 'fas fa-bars '
                    },
                    buttonType: ButtonType.CIRCLE,
                    buttonColorType: ButtonColorType.SUCCESS,
                    hoverText: 'Existing Integrations',
                    function: () => {
                        this.openIntegrationsListingModal(response);
                    }
                });
            }
        }
    }
    onIntegrate() {
        this.openParentIntegrationModal(this.response, 'Autotask Setup');
    }
    openParentIntegrationModal(response, modalName: string) {
        const modalArgs: IModalData = {
            modalName: modalName,
            sourceId: this.widgetRef.widgetData.widgetUniqueIdentifier,
            modalType: ModalType.MIDDLE,
            modalIcon: {
                type: IconType.FONTAWSOME,
                class: 'fas fa-wrench'
            },
            extraStepContainerClass: 'remove-form-space',
            modalSteps: [
                {
                    stepName: 'Credentials',
                    resetModal: true,
                    stepData: {
                        componentToLoad:
                            AutotaskParentIntegrationStepOneComponent,
                        payload: {
                            data: {
                                response: response,
                                widgetRef: this.widgetRef
                            }
                        }
                    }
                },
                {
                    stepName: 'Configure Fields',
                    resetModal: true,
                    stepData: {
                        componentToLoad:
                            AutotaskParentIntegrationStepTwoComponent,
                        payload: {
                            data: {
                                response: response,
                                widgetRef: this.widgetRef
                            }
                        }
                    },
                    stepHeightVh: 60
                }
            ],
            modalWidthVw: 60,
            modalHeightPx: 450,
            noBottomPadding: true
        };
        this.widgetRef.modalService.openModal(modalArgs);
    }

    openIntegrationsListingModal(response) {
        const modalArgs: IModalData = {
            modalName: 'Existing Integrations',
            sourceId: this.widgetRef.widgetData.widgetUniqueIdentifier,
            modalType: ModalType.MIDDLE,
            modalIcon: {
                type: IconType.FONTAWSOME,
                class: 'fas fa-ticket-alt'
            },
            extraStepContainerClass: 'remove-form-space',
            modalSteps: [
                {
                    stepName: 'Integrations List',
                    resetModal: true,
                    stepData: {
                        componentToLoad: AutotaskIntegrationsTableComponent,
                        payload: {
                            data: {
                                response: response,
                                widgetRef: this.widgetRef
                            }
                        }
                    }
                }
            ],
            modalWidthVw: 60,
            modalHeightVh: 60
        };
        this.widgetRef.modalService.openModal(modalArgs);
    }

    openChildIntegrationModal(response) {
        const modalArgs: IModalData = {
            modalName: 'Autotask Setup',
            sourceId: this.widgetRef.widgetData.widgetUniqueIdentifier,
            modalType: ModalType.MIDDLE,
            modalIcon: {
                type: IconType.FONTAWSOME,
                class: 'fas fa-ticket-alt'
            },
            extraStepContainerClass: 'remove-form-space',
            modalSteps: [
                {
                    stepName: 'Credentials',
                    resetModal: true,
                    stepData: {
                        componentToLoad: AutotaskChildIntegrationComponent,
                        payload: {
                            data: {
                                response: response,
                                widgetRef: this.widgetRef
                            }
                        }
                    }
                }
            ],

            modalWidthVw: 60,
            modalHeightVh: 60,
            noBottomPadding: true
        };
        this.widgetRef.modalService.openModal(modalArgs);
    }

    bindData(response: IIntegrationApiResponse): void {
        this.response = response;
        this.isOwnerIntegrated = response['ownerIntegration'];
        this.isChildIntegrated = response['childIntegration'];
        this.isParentIntegrated = response['parentIntegration'];

        this.integrationInput.buttons = [];
        this.generateButtons(response);
        this.widgetRef.endLoader();
    }

    ngAfterViewInit(): void {
        this.widgetRef.setBindData(this.bindData.bind(this));
    }
}
